App.addModule(function(app) {

    if (!app.getConfig('matomo/general/enabled') || !app.getConfig('matomo/general/script_url') || !app.get('customer.can_track')) {
        return
    }

    window.matomoAsyncInit = function() {

        function round(x) {
	        return Math.round(x * 100) / 100;
        }
        
        const tracker = Matomo.addTracker(app.getConfig('matomo/general/tracker_url'),
                                          app.getConfig('matomo/general/site_id'))
        
        tracker.enableLinkTracking()
        
        if (cm) {

//            tracker.setCookieNamePrefix('_mia_')
            tracker.requireCookieConsent()

            cm.addCallback('performance', () => {
             	tracker.rememberCookieConsentGiven()
            })
        }
        else {
            tracker.disableCookies()
        }
        
        if (window.URL) {
            const url = new URL(document.location.href)
            url.searchParams.delete('gad_source')
            tracker.setCustomUrl(url.toString())
        }
        
        if (product = app.get('current_product')) {

	        tracker.setEcommerceView(
                product.sku,
                '['+ product.sku +'] ' + product.name,
                product.product_type,
                round(product.base_price)
            )
        }

        tracker.trackPageView()
        
        app.on('cart:update', () => {

            Object.values(app.get('checkout.cart.items')).forEach(item => {

            	const product = item.product

    	        tracker.addEcommerceItem(
                    product.sku,
                    '['+ product.sku +'] ' + product.name,
                    product.product_type,
                    round(item.base_price),
                    item.qty
                )
        	})
        	
        	tracker.trackEcommerceCartUpdate(round(app.get('checkout.cart.base_subtotal')))
        })
        
        const order = app.get('checkout.order')

        if (order) {

            Object.values(order.items).forEach(item => {

            	const product = item.product

    	        tracker.addEcommerceItem(
                    product.sku,
                    '['+ product.sku +'] ' + product.name,
                    product.product_type,
                    round(item.base_price),
                    item.qty_ordered
                )
            })
        	
        	tracker.trackEcommerceOrder(
                order.increment_id,
                round(order.base_subtotal + order.base_shipping_amount),
		        round(order.base_subtotal),
                round(order.base_tax_amount),
                round(order.base_shipping_amount)
            )
        }
    }

    app.loadScript(app.getConfig('matomo/general/script_url'))
})
